import { useNavigate, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faBuildingColumns,
  faBriefcase,
  faListCheck,
  faMoneyBill,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";


function Sidebar() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/jobseeker/login"); // redirect to login page
  };

  if (!token) return null; // hide sidebar if not logged in

  return (
    <div className="panelSidebar">
      <ul className="mainsidebar">
        <li>
          <NavLink
            to="/jobseeker/dashboard"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faHouse} className="c" />
            {/* <img
              src={`${process.env.PUBLIC_URL}/assets/img/icons/dashboard.svg`}
              alt="ico"
            />{" "} */}
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/jobseeker/profile"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faUser} className="sidebar-icon" />
            {/* <img
              src={`${process.env.PUBLIC_URL}/assets/img/icons/dashboard.svg`}
              alt="ico"
            />{" "} */}
            Profile
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/jobseeker/bank"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faBuildingColumns} className="sidebar-icon" />
            Bank Details
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            to="/jobseeker/saved-jobs"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/icons/dashboard.svg`}
              alt="ico"
            />{" "}
            Dashboard
          </NavLink>
        </li> */}
        <li>
          <NavLink
            to="/jobseeker/jobs-applied"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faBriefcase} className="sidebar-icon" />
            Jobs Applied
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/jobseeker/manage-task"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faListCheck} className="sidebar-icon" />
            Manage Task
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/jobseeker/payment-history"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faMoneyBill} className="sidebar-icon" />
            Payment History
          </NavLink>
        </li>
        <li>
          <button
            type="button"
            onClick={handleLogout}
            style={{ backgroundColor: "inherit", border: "none", cursor: "pointer" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/icons/logout.svg`}
              alt="ico"
              width="12px"
            />{" "}
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;